// @ts-nocheck
/**
 * GeChiUI dependencies
 */
import { createContext } from '@gechiui/element';

export const SlotFillContext = createContext( {
	registerSlot: () => {},
	unregisterSlot: () => {},
	registerFill: () => {},
	unregisterFill: () => {},
	getSlot: () => {},
	getFills: () => {},
	subscribe: () => {},
} );

export default SlotFillContext;
